import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  Email: yup
    .string()
    .required('Email is required.')
    .email('Please enter a valid Email Address.'),
  FirstName: yup
    .string()
    .required('First Name is required.')
    .matches(
      /^[a-zA-Z ]*$/,
      'Input cannot have numbers or special characters.'
    ),
  LastName: yup
    .string()
    .required('Last Name is required.')
    .matches(
      /^[a-zA-Z ]*$/,
      'Input cannot have numbers or special characters.'
    ),
  PhoneNumber: yup
    .string()
    .required('Phone number is required.')
    .min(14, 'Please enter a valid phone number.'),
});
